<template>
  <div class="classCard">
    <div class="cardContainer">
      <div class="cardHeader">
        <div class="instructorDetails">
          <b class="instructorName"
            >{{ course.activeInstructor.user.firstName }}
            {{ course.activeInstructor.user.lastName }}</b
          >
          <div class="classType">{{ course.curriculum.program.name }}</div>
        </div>
        <div class="gradeSection">
          <div class="gradeBadge">
            <b
              class="grade"
              :style="{
                color: gradeColor(percentageToLetter(course.averageGrade)),
              }"
              >{{ percentageToLetter(course.averageGrade) }}</b
            >
          </div>
          <div
            class="gradeDetails"
            :style="{
              backgroundColor: gradeColor(
                percentageToLetter(course.averageGrade),
              ),
            }"
          >
            <div class="grade">
              Grade: {{ course.averageGrade.toFixed(2) }}%
            </div>
          </div>
        </div>
      </div>
      <div class="classDates">
        <div class="date">
          {{ course.startDate.toLocaleDateString() }} -
          {{ course.endDate.toLocaleDateString() }}
        </div>
      </div>
      <img
        v-if="course.active"
        class="verticalDots"
        src="/static/img/vertical_dots.svg"
        alt=""
        @click="toggleEdit"
      />
    </div>
    <div
      v-for="(student, index) in course.students"
      :key="index"
      class="studentList"
    >
      <div class="studentRow">
        <div class="studentNameSmall" @click="openNotes(student)">
          {{ student.user.firstName }}
          {{ student.user.lastName }}
        </div>
        <div class="studentGrades" v-if="!editMode">
          <div
            class="gradeCircle"
            :style="{
              backgroundColor: gradeColor(
                percentageToLetter(student.averageGrade),
              ),
            }"
          >
            <b class="gradeLetterSmall">
              {{ percentageToLetter(student.averageGrade) }}
            </b>
          </div>
          <div
            class="aheadBehind"
            :style="{ backgroundColor: gradeColor(student.daysMargin) }"
            v-if="course.active"
          >
            <b class="aheadBehindNumber">
              {{ student.daysMargin }}
            </b>
          </div>
        </div>
        <img
          class="trashIcon"
          v-else
          src="/static/img/Trash.svg"
          alt=""
          @click="removeStudentFromClass(student.id)"
        />
      </div>
      <hr v-if="index < course.students.length - 1" class="dividerLine" />
    </div>
    <div class="footerContainer" v-if="course.active">
      <div class="buttons">
        <button class="buttonWrapper" @click="goToClassGradeBook">
          Grade Book
        </button>
        <button class="buttonWrapper" @click="openClassView">Classroom</button>
        <button class="buttonWrapper" @click="archiveClass()">Archive</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ClassCards",
  props: {
    course: Object,
  },
  data() {
    return {
      editMode: false,
    };
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  methods: {
    percentageToLetter(percent) {
      if (percent >= 90) return "A";
      else if (percent < 90 && percent >= 80) return "B";
      else if (percent < 80 && percent >= 70) return "C";
      else if (percent < 70 && percent >= 60) return "D";
      else return "F";
    },
    gradeColor(value) {
      switch (value) {
        case "A":
          return "#00a551";
        case "B":
          return "#5ed053";
        case "C":
          return "#ffe101";
        case "D":
          return "#ff8800";
        case "F":
          return "#ff0000";
      }
      if (value >= 0) {
        return "#00a551";
      } else if (value >= -2) {
        return "#ffe101";
      } else if (value >= -4) {
        return "#ff8800";
      } else {
        return "#ff0000";
      }
    },
    goToClassGradeBook() {
      this.$emit("goToClassGradeBook", this.course.id);
    },
    openClassView() {
      this.$emit("class", this.course.id);
    },
    archiveClass() {
      this.$emit("archive", this.course.id);
    },
    openNotes(student) {
      this.$emit("notes", student);
    },
    toggleEdit() {
      this.editMode = !this.editMode;
    },
    removeStudentFromClass(studentId) {
      this.$emit("remove", studentId);
    },
    handleOutsideClick(event) {
      if (
        !event.target.closest(".verticalDots") &&
        !event.target.closest(".trashIcon")
      ) {
        this.editMode = false;
      }
    },
  },
};
</script>
<style scoped>
.verticalDots {
  width: 25px;
  height: 25px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.trashIcon {
  width: 30px;
  height: 30px;
}
.instructorName {
  font-size: 30px;
  font-weight: bold;
  align-self: stretch;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.classType {
  align-self: stretch;
  position: relative;
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.instructorDetails {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 5px;
}
.grade,
.date,
.studentNameSmall {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gradeBadge {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.gradeDetails {
  align-self: stretch;
  border-radius: 5px;
  background-color: #5ed053;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  box-sizing: border-box;
  text-align: left;
  font-size: 15px;
  color: #fff;
}
.gradeSection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 7px;
  text-align: center;
  color: #5ed053;
}
.cardHeader {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 40px;
}
.classDates {
  width: 319.3px;
  height: 17px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.cardContainer {
  align-self: stretch;
  background-color: #e8f0ff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px;
  gap: 5px;
  position: relative;
}
.gradeCircle {
  border-radius: 20px;
  background-color: #00a551;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px;
}
.gradeLetterSmall,
.aheadBehindNumber {
  position: relative;
  line-height: 25px;
}
.aheadBehind {
  border-radius: 20px;
  background-color: #ff0000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px;
}
.gradeCircle,
.aheadBehind {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.studentGrades {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  text-align: center;
  font-size: 13px;
  color: #fff;
}
.studentRow {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.studentList {
  align-self: stretch;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 10px;
  gap: 5px;
}
.dividerLine {
  border: 0;
  border-top: 1px solid #ddd;
  height: 0;
  margin: 5px 0;
  width: 100%;
  box-sizing: border-box;
}
.buttonWrapper {
  flex: 1;
  border-radius: 5px;
  background-color: rgba(64, 64, 64, 0.25);
  padding: 2px 20px;
  box-sizing: border-box;
  cursor: pointer;
  white-space: nowrap;
  font-weight: normal;
  color: #404040;
  font-size: 15px;
}
.buttons {
  align-self: stretch;
  height: 27px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.footerContainer {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: auto;
  padding: 5px 10px 0;
  text-align: center;
}
.classCard {
  width: 100%;
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 0 10px;
  box-sizing: border-box;
  gap: 10px;
  text-align: left;
  font-size: 15px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
